import React from "react";
import { FaRegAddressCard, FaEnvelope } from "react-icons/fa";

const KanbanView = ({
  cards,
  stateMap,
  handleCardClick,
  handleEnvelopeClick,
  selectedCards,
  setSelectedCards,
  setSelectedCustomers,
  onChangeStatus,
  loading,
}) => {
  const handleRowSelection = (cardId, customerId) => {
    setSelectedCards((prevSelectedCards) =>
      prevSelectedCards.includes(cardId)
        ? prevSelectedCards.filter((id) => id !== cardId)
        : [...prevSelectedCards, cardId]
    );
    setSelectedCustomers((prevSelectedCustomer) =>
      prevSelectedCustomer.includes(customerId)
        ? prevSelectedCustomer.filter((id) => id !== customerId)
        : [...prevSelectedCustomer, customerId]
    )
  };

  const getPrintByDateColor = (printByDate, status) => {
    const today = new Date();
    const date = new Date(printByDate);
    const isLate = today > date;
    const isToday = today.toDateString() === date.toDateString();

    if (status === "awaiting action") {
      if (isLate) return "bg-red-500 text-white";
      if (isToday) return "bg-orange-500 text-white";
    }
    return "";
  };

  const renderCard = (card) => (
    <div key={card._id} className="bg-white shadow-md p-4 mb-4 squared">
      <div className="flex items-center justify-between">
        <div>
          <p>
            <strong>Event Date:</strong>{" "}
            {/* {new Date(card.finaleventdate).toLocaleDateString()} */}
            {new Date(card.eventDate).toLocaleDateString()}
          </p>
          <p>
            <strong>Print By Date:</strong>{" "}
            <span
              className={` ${getPrintByDateColor(
                card.printByDate,
                card.status
              )}`}
            >
              {/* {new Date(card.printByDate).toLocaleDateString()} */}
              {new Date(
                new Date(card.eventDate).setDate(
                  new Date(card.eventDate).getDate() - 5
                )
              ).toLocaleDateString()}
            </span>
          </p>
          <p>
            <strong>Locked:</strong>{" "}
            <span
              className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                card.isLocked
                  ? "bg-red-100 text-primary-dark"
                  : "bg-green-100 text-green-800"
              }`}
            >
              {card.isLocked ? "Yes" : "No"}
            </span>
          </p>
          <p>
            <strong>Street:</strong> {card.receiptsId.streetAddress}
          </p>
          <p>
            <strong>City:</strong> {card.receiptsId.city},
          </p>
          <p>
            <strong>State:</strong>{" "}
            {stateMap[card.receiptsId.stateId] || card.receiptsId.stateId},
          </p>
          <p>
            <strong>ZipCode:</strong> {card.receiptsId.zipCode}
          </p>
          <p>
            <strong>Recipient Name:</strong> {card.receiptsId.fullName}
          </p>
          <p>
            <strong>User Name:</strong> {card.customerId.fullName}
          </p>
          <p>
            <strong>Event Name:</strong> {card.eventId.name}
          </p>
          <p>
            <strong>Subscription Status:</strong>{" "}
            {card.customerId.isSubscribed ? "Subscribed" : "Not Subscribed"}
          </p>
          <p>
            <strong>Email of Recipient:</strong> {card.receiptsId.email}
          </p>
          <p>
            <strong>Recipient Gender:</strong> {card.receiptsId.gender}
          </p>
        </div>
        <div className="flex space-x-2">
          <button
            onClick={() => handleCardClick(card)}
            className="text-primary hover:text-primary-dark"
          >
            <FaRegAddressCard />
          </button>
          <button
            onClick={() => handleEnvelopeClick(card)}
            className="text-blue-600 hover:text-blue-800"
          >
            <FaEnvelope />
          </button>
          {card.status === "awaiting action" && (
            <input
              type="checkbox"
              checked={selectedCards.includes(card._id)}
              onChange={() => {
                handleRowSelection(card._id, card.customerId._id )
              }}
              className="form-checkbox h-4 w-4 accent-primary transition duration-150 ease-in-out bg-red"
            />
          )}
        </div>
      </div>
    </div>
  );
  return (
    <div className="flex flex-col md:flex-row md:space-x-4">
      <div className="flex-1 bg-gray-100 p-4 squared">
        <h2 className="text-lg font-semibold mb-4">Awaiting Action</h2>
        {cards
          .filter((card) => card.status === "awaiting action")
          .map(renderCard)}
      </div>
      <div className="flex-1 bg-gray-100 p-4 squared">
        <h2 className="text-lg font-semibold mb-4">Printed but Not Mailed</h2>
        {cards.filter((card) => card.status === "printed").map(renderCard)}
      </div>
      <div className="flex-1 bg-gray-100 p-4 squared">
        <h2 className="text-lg font-semibold mb-4">Mailed</h2>
        {cards.filter((card) => card.status === "mailed").map(renderCard)}
      </div>
    </div>
  );
};

export default KanbanView;
